import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import AverageLastResponse from './AverageLastResponse';
import AverageAllResponse from './AverageAllResponse';

const Dashboard = () => {
  const [activeKey, setActiveKey] = useState(1);
  const [lazyLoadTab, setLazyLoadTab] = useState(false);

  const contentStyle = { padding: '30px 0' };

  const handleSelect = (key) => {
    if (key === 2) {
      setLazyLoadTab(true);
    }
    setActiveKey(key);
  };

  return (
    <div>
      <h2 style={{ padding: '30px 0' }}>Hypertension Dashboard</h2>
      <Tabs activeKey={activeKey} onSelect={handleSelect} id="htn-dashboard-tabs">
        <Tab eventKey={1} title={'Average of Last Data Submitted'}>
          <div style={contentStyle}>
            <AverageLastResponse category="HTN" />
          </div>
        </Tab>
        <Tab eventKey={2} title={'Hypertension Average after 60 days'}>
          {lazyLoadTab && (
            <div style={contentStyle}>
              <AverageAllResponse category="HTN" />
            </div>
          )}
        </Tab>
      </Tabs>
    </div>
  );
};

export default Dashboard;
